module.exports = __webpack_public_path__ + "img/left-leg_hover.9ad31380.png";